import { axiosInstance } from "./";

const getCountries = async (params) =>
  await axiosInstance.get("countries", { params });

export { getCountries };
